/**
 * Determines if PESEL validation should be skipped for a given country.
 * PESEL and document number are PL-specific identity documents.
 *
 * @param country - The country code to check
 * @returns True if PESEL validation should be skipped
 *
 * @__NO_SIDE_EFFECTS__
 */
export function shouldSkipPeselValidation(country) {
    return country !== 'PL';
}
//# sourceMappingURL=shouldSkipPeselValidation.js.map